import React from 'react'
import MaterialSymbol from '../material-symbol'

const AddComment = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="add_comment" {...props} />
))

AddComment.displayName = 'AddComment'

export default AddComment
